const CFEditAccount = (() => {
    //Inputs
    let CFConsumerBtns;
    let consumerRow;
    let consumerElement;
    var selectedConsumers;
    var selectedConsumersName;
    var selectedConsumersId;

    //filter
    let accountId = '0';
    let BtnName;
    let page;
    let load;
    let IsDisabledAccount = false;
    let accountPermission;
    let tempAccountPer;
    let backPage;

    // attachment 
    let attachmentBtn;
    let attachmentCount;
    let accountListForAttachmentCount = [];
    let editAttachmentPopup;
    let numberOfRows;
    let btnWrapInputsN = [];
    let descriptionInputN = [];
    let startDateInputN = [];
    let categoryDropdownN = [];
    let endDateInputN = [];
    let deleteBtnN = [];
    let downloadBtnN = [];
    let showInactive;
    let accountAttachments = [];
    let attachmentPopupBtnWrap;
    let categoryAttachmentData;
    let isValueChanged;
    let deletedIds = [];
    let newAttachmentArray = [];
    // Attachment Elements
    let attachmentList, attachmentInput, attachmentContainer;
    let reviewAttachmentList, newAttachmentList;

    // get the Consumers selected from the Roster
    async function handleActionNavEvent(target) {
        var targetAction = target.dataset.actionNav;

        switch (targetAction) {
            case 'miniRosterDone': {
                selectedConsumers = roster2.getActiveConsumers();
                page = 'Update';
                backPage = 1;
                load = 1;
                account = '';
                accountId = '0';
                attachmentCount = 0;
                await loadCFEditLanding();
                DOM.toggleNavLayout();
                break;
            }
            case 'miniRosterCancel': {
                DOM.toggleNavLayout();
                loadApp('home');
                break;
            }
        }
    }

    async function loadCFEditFromAccountRegister(Consumers) {
        setActiveModuleAttribute('CFEditAccount');
        backPage = 2;
        DOM.clearActionCenter();
        selectedConsumers = Consumers;
        page = 'Update';
        load = 1;
        await loadCFEditLanding();
        DOM.toggleNavLayout();
    }

    // Build OOD Module Landing Page
    async function loadCFEditLanding() {
        DOM.clearActionCenter();
        DOM.scrollToTopOfPage();

        if (!document.querySelector('.consumerListBtn')) roster2.miniRosterinit();

        landingPage = document.createElement('div');
        var LineBr = document.createElement('br');
        getaccountPermission();
        selectedConsumersId = selectedConsumers[selectedConsumers.length - 1].id;
        const name = (
            await ConsumerFinancesAjax.getConsumerNameByID({
                token: $.session.Token,
                consumerId: selectedConsumersId,
            })
        ).getConsumerNameByIDResult;

        selectedConsumersName = name[selectedConsumers.length - 1].FullName;

        const resultAccount = await ConsumerFinancesAjax.getEditAccountAsync(selectedConsumersId, accountPermission);
        const { getEditAccountResult } = resultAccount;
        accountListForAttachmentCount = getEditAccountResult;

        if (getEditAccountResult.length > 0 && load == 1) {
            account = getEditAccountResult[0].accountName;
            accountId = getEditAccountResult[0].accountId;   
            attachmentCount = getEditAccountResult[0].attachmentCount;   
        }

        if (getEditAccountResult.length > 0 && load == 2) { 
            attachmentCount = accountListForAttachmentCount.find(a => a.accountId == accountId).attachmentCount;
        }
               
        if (page == 'Update') {
            const topButton = buildHeaderButton();
            landingPage.appendChild(topButton);
            border = document.createElement('div');
            border.classList.add('borderLine');
            landingPage.appendChild(LineBr);
            landingPage.appendChild(LineBr);
            landingPage.appendChild(border);
            landingPage.appendChild(LineBr);
        }

        const importantAccountForm = await buildAccountForm();
        landingPage.appendChild(importantAccountForm);
        populateAccountDropdown();
        DOM.ACTIONCENTER.appendChild(landingPage);
    }

    // build display of Account and button
    function buildHeaderButton() {
        consumerElement = document.createElement('div');
        consumerRow = document.createElement('div');
        consumerRow.classList.add('consumerHeader');
        CFConsumerBtns = buildButtonBar();
        consumerRow.appendChild(CFConsumerBtns);
        consumerElement.appendChild(consumerRow);
        return consumerElement;
    }

    // build display of "New Account"
    function buildButtonBar() {
        const buttonBar = document.createElement('div');
        buttonBar.classList.add('OODbuttonBar');
        buttonBar.style.maxHeight = '50px';
        buttonBar.style.minWidth = '100%';

        const dropdownButtonBar = document.createElement('div');
        const entryButtonBar = document.createElement('div');
        const attachmentBar = document.createElement('div');
        dropdownButtonBar.style.width = '40%';
        entryButtonBar.style.width = '32%';
        attachmentBar.style.width = '22%';

        accountDropdown = dropdown.build({
            label: 'Accounts:',
            dropdownId: 'accountDropdown',
        });

        accountDropdown.addEventListener('change', event => {
            accountId = event.target.value;
            account = event.target.options[event.target.selectedIndex].id;
            page = 'Update';
            load = 2;
            attachmentCount = accountListForAttachmentCount.find(a => a.accountId == accountId).attachmentCount;
            loadCFEditLanding();
        });

        const entryBtn = button.build({
            text: 'ADD ACCOUNT',
            style: 'secondary',
            type: 'contained',
            classNames: 'newEntryBtn',
            readonly: $.session.CFInsertAccounts,
            callback: async () => {
                if (!entryBtn.classList.contains('disabled')) {
                    page = 'Add';
                    loadCFEditLanding();
                }
            },
        });

        attachmentBtn = button.build({
            id: `attachedAccount`,
            text: `ATTACHMENTS (${attachmentCount})`,
            style: 'secondary',
            type: 'contained',
            icon: 'attachment',
            callback: () => {
                attachmentEditPopup(false, accountId, account);
            },
        });

        if ($.session.CFInsertAccounts) {
            entryBtn.classList.remove('disabled');
        } else {
            entryBtn.classList.add('disabled');
        }
        if (accountListForAttachmentCount.length > 0) {
            attachmentBtn.classList.remove('disabled');
        } else {
            attachmentBtn.classList.add('disabled');
        }

        entryBtn.style.height = '50px';
        entryBtn.style.minWidth = '100%';
        attachmentBtn.style.height = '50px';
        attachmentBtn.style.minWidth = '100%';
        accountDropdown.style.minWidth = '100%';
        dropdownButtonBar.appendChild(accountDropdown);
        entryButtonBar.appendChild(entryBtn);
        entryButtonBar.style.marginLeft = '3%';
        attachmentBar.appendChild(attachmentBtn);
        attachmentBar.style.marginLeft = '3%';
        buttonBar.appendChild(dropdownButtonBar);
        buttonBar.appendChild(entryButtonBar);
        buttonBar.appendChild(attachmentBar);
        return buttonBar;
    }

    async function buildAccountForm() {
        disabledEnabledAccounts();
        const employeeInfoDiv = document.createElement('div');
        employeeInfoDiv.classList.add('additionalQuestionWrap');

        name = '';
        number = '';
        type = '';
        status = '';
        classofAccount = null;
        dateClosed = null;
        lastReconciled = '';
        openingBalance = '';
        balance = '';
        description = '';
        dateOpened = null;

        nameTemp = '';
        numberTemp = '';
        typeTemp = '';
        statusTemp = '';
        classofAccountTemp = '';
        dateOpenedTemp = '';
        dateClosedTemp = '';
        openingBalanceTemp = '';
        descriptionTemp = '';

        if (page == 'Update') {
            if (accountId != '' && accountId != '0') {
                const result = await ConsumerFinancesAjax.getEditAccountInfoByIdAsync(accountId);
                const { getEditAccountInfoByIdResult } = result;
                name = getEditAccountInfoByIdResult[0].name;
                number = getEditAccountInfoByIdResult[0].number;
                type = getEditAccountInfoByIdResult[0].type;
                status = getEditAccountInfoByIdResult[0].status;
                classofAccount = getEditAccountInfoByIdResult[0].classofAccount;
                dateOpened =
                    getEditAccountInfoByIdResult[0].dateOpened == ''
                        ? null
                        : moment(getEditAccountInfoByIdResult[0].dateOpened).format('YYYY-MM-DD');
                dateClosed =
                    getEditAccountInfoByIdResult[0].dateClosed == ''
                        ? null
                        : moment(getEditAccountInfoByIdResult[0].dateClosed).format('YYYY-MM-DD');
                lastReconciled =
                    getEditAccountInfoByIdResult[0].lastReconciled == ''
                        ? null
                        : moment(getEditAccountInfoByIdResult[0].lastReconciled).format('YYYY-MM-DD');
                openingBalance = getEditAccountInfoByIdResult[0].openingBalance;
                balance = getEditAccountInfoByIdResult[0].balance;
                description = getEditAccountInfoByIdResult[0].description;
            } else {
                account = '';
            }
            BtnName = 'UPDATE';
        } else {
            BtnName = 'SAVE';
            dateOpened = UTIL.getTodaysDate();
            accountId = '0';
            account = '';
        }

        inputName = input.build({
            id: 'inputName',
            type: 'text',
            label: 'Name',
            style: 'secondary',
            readonly: IsDisabledAccount,
            value: name ? name : '',
        });
        inputNumber = input.build({
            id: 'inputNumber',
            type: 'number',
            label: 'Number',
            style: 'secondary',
            readonly: IsDisabledAccount,
            value: number ? number : '',
        });
        typeDropdown = dropdown.build({
            id: 'typeDropdown',
            label: 'Type',
            dropdownId: 'typeDropdown',
            readonly: IsDisabledAccount,
            value: type ? type : '',
        });
        statusDropdown = dropdown.build({
            id: 'statusDropdown',
            label: 'Status',
            dropdownId: 'statusDropdown',
            readonly: IsDisabledAccount,
            value: status ? status : '',
        });
        classDropdown = dropdown.build({
            id: 'classDropdown',
            label: 'Class',
            dropdownId: 'classDropdown',
            readonly: IsDisabledAccount,
            value: classofAccount ? classofAccount : '',
        });
        opendDate = input.build({
            id: 'opendDate',
            type: 'date',
            label: 'Date Opened',
            style: 'secondary',
            readonly: IsDisabledAccount,
            value: dateOpened ? dateOpened : '',
        });
        closeDate = input.build({
            id: 'closeDate',
            type: 'date',
            label: 'Date Closed',
            style: 'secondary',
            readonly: IsDisabledAccount,
            value: dateClosed ? dateClosed : '',
        });
        lastReconciledDate = input.build({
            id: 'lastReconciledDate',
            type: 'date',
            label: 'Last Reconciled',
            style: 'secondary',
            readonly: true,
            value: lastReconciled ? lastReconciled : '',
        });
        inputOpeningBal = input.build({
            id: 'inputOpeningBal',
            type: 'text',
            label: 'Opening Balance',
            style: 'secondary',
            readonly: IsDisabledAccount,
            value: openingBalance ? '$' + openingBalance : '',
        });
        inputBal = input.build({
            id: 'inputBal',
            type: 'text',
            label: 'Balance',
            style: 'secondary',
            readonly: true,
            value: balance ? '$' + balance : '',
        });

        inputDesc = input.build({
            id: 'inputDesc',
            type: 'text',
            label: 'Description',
            style: 'secondary',
            readonly: IsDisabledAccount,
            value: description ? description : '',
        });

        // button
        SAVE_BTN = button.build({
            text: BtnName,
            style: 'secondary',
            type: 'contained',
            icon: 'save',
            readonly: IsDisabledAccount,
            callback: async () => {
                if (!SAVE_BTN.classList.contains('disabled')) {
                    SAVE_BTN.classList.add('disabled');
                    await saveUpdateAccount();
                }
            },
        });
        CANCEL_BTN = button.build({
            text: 'Cancel',
            style: 'secondary',
            type: 'outlined',
            callback: async () => {
                if (backPage == 1) cancleAccount();
                else {
                    ConsumerFinances.backFromConsumerFinanceEditAccount(selectedConsumers);
                }
            },
        });

        const column1 = document.createElement('div');
        column1.classList.add('col-1');
        const addNewCard = document.createElement('div');
        addNewCard.classList.add('card');
        const addNewCardBody = document.createElement('div');
        addNewCardBody.classList.add('card__body');
        if (page == 'Add') {
            addNewCard.innerHTML = `<div class="card__header">${selectedConsumersName} </div>`;
        } else {
            addNewCard.innerHTML = `<div class="card__header">${selectedConsumersName} <br> Account : ${account} </div>`;
        }

        addNewCard.appendChild(addNewCardBody);
        column1.appendChild(addNewCard);

        var drWrap = document.createElement('div');
        drWrap.classList.add('editAccountDTWrap');
        inputName.classList.add('width23Per');
        drWrap.appendChild(inputName);
        inputNumber.classList.add('width23Per');
        drWrap.appendChild(inputNumber);
        typeDropdown.classList.add('width16Per');
        drWrap.appendChild(typeDropdown);
        statusDropdown.classList.add('width16Per');
        drWrap.appendChild(statusDropdown);
        classDropdown.classList.add('width16Per');
        drWrap.appendChild(classDropdown);
        addNewCardBody.appendChild(drWrap);

        var drWrap1 = document.createElement('div');
        drWrap1.classList.add('editAccountDTWrap');
        drWrap1.classList.add('width50Per');
        opendDate.classList.add('width32Per');
        drWrap1.appendChild(opendDate);
        inputOpeningBal.classList.add('width32Per');
        drWrap1.appendChild(inputOpeningBal);
        closeDate.classList.add('width32Per');
        drWrap1.appendChild(closeDate);
        addNewCardBody.appendChild(drWrap1);

        var drWrap2 = document.createElement('div');
        drWrap2.classList.add('editAccountDTWrap');
        drWrap2.classList.add('width33Per');

        lastReconciledDate.classList.add('width50Per');
        drWrap2.appendChild(lastReconciledDate);
        inputBal.classList.add('width50Per');
        drWrap2.appendChild(inputBal);
        //addNewCardBody.appendChild(drWrap2);  //Due to new requirenment hide reconciled and opening balance

        var drWrap3 = document.createElement('div');
        drWrap3.classList.add('editAccountDTWrap');
        inputDesc.classList.add('width50Per');
        drWrap3.appendChild(inputDesc);
        addNewCardBody.appendChild(drWrap3);

        var btnWrap = document.createElement('div');
        btnWrap.classList.add('editAccountBtnWrap');
        btnWrap.style.marginLeft = '25%';
        btnWrap.style.width = '50%';

        SAVE_BTN.style.width = '52%';
        btnWrap.appendChild(SAVE_BTN);

        CANCEL_BTN.style.width = '52%';
        CANCEL_BTN.style.marginLeft = '5%';
        btnWrap.appendChild(CANCEL_BTN);
        addNewCardBody.appendChild(btnWrap);

        employeeInfoDiv.appendChild(column1);
        populateDropdown();
        eventListeners();

        checkRequiredFieldsOfAccountInfo(name, type, status, dateOpened, dateClosed, classofAccount);
        return employeeInfoDiv;
    }

    function disabledEnabledAccounts() {
        if ($.session.CFUpdateEditAccounts && page == 'Update') {
            IsDisabledAccount = false;
        } else if ($.session.CFInsertAccounts && page == 'Add') {
            IsDisabledAccount = false;
        } else {
            IsDisabledAccount = true;
        }
    }
    // Populate the Account DDL
    async function populateAccountDropdown() {
        const { getEditAccountResult: accounts } = await ConsumerFinancesAjax.getEditAccountAsync(
            selectedConsumersId,
            accountPermission,
        );

        let dataAccount = accounts.map(account => ({
            id: account.accountName,
            value: account.accountId,
            text: account.accountName + ' - $' + (account.totalBalance == '' ? '0.00' : account.totalBalance),
        }));
        dropdown.populate('accountDropdown', dataAccount, accountId);
    }

    async function populateDropdown() {
        const { getAccountClassResult: classAccount } = await ConsumerFinancesAjax.getAccountClassAsync();
        let dataClass = classAccount.map(accountClass => ({
            id: accountClass.SystemClass,
            value: accountClass.accountClass,
            text: accountClass.accountClass,
        }));
        dataClass.unshift({ id: null, value: '', text: '' }); //ADD Blank value
        dropdown.populate('classDropdown', dataClass, classofAccount);

        const typeData = [
            { id: 1, value: 'A', text: 'Asset ' },
            { id: 2, value: 'L', text: 'Liability' },
        ];
        typeData.unshift({ id: null, value: '', text: '' });
        dropdown.populate('typeDropdown', typeData, type);

        const statusData = [
            { id: 1, value: 'O', text: 'Open' },
            { id: 2, value: 'I', text: 'Inactive' },
            { id: 3, value: 'C', text: 'Closed' },
        ];
        statusData.unshift({ id: null, value: '', text: '' });
        dropdown.populate('statusDropdown', statusData, status);
    }

    function eventListeners() {
        inputName.addEventListener('input', event => {
            nameTemp = 'Changed';
            name = event.target.value.trim();
            getRequiredFieldsOfAccountInfo();
        });
        inputNumber.addEventListener('input', event => {
            numberTemp = 'Changed';
            number = event.target.value;
            getRequiredFieldsOfAccountInfo();
        });
        opendDate.addEventListener('input', event => {
            dateOpenedTemp = 'Changed';
            dateOpened = event.target.value;
            getRequiredFieldsOfAccountInfo();
        });
        closeDate.addEventListener('input', event => {
            dateClosedTemp = 'Changed';
            dateClosed = event.target.value;
            getRequiredFieldsOfAccountInfo();
        });
        inputDesc.addEventListener('input', event => {
            descriptionTemp = 'Changed';
            description = event.target.value;
            getRequiredFieldsOfAccountInfo();
        });
        inputOpeningBal.addEventListener('input', event => {
            let minAmount = event.target.value;
            var reg = new RegExp('^[0-9 . $ -]+$');
            if (!reg.test(minAmount) && minAmount != '') {
                document.getElementById('inputOpeningBal').value = minAmount.substring(0, minAmount.length - 1);
                return;
            } else if (
                minAmount.includes('.') &&
                (minAmount.match(/\./g).length > 1 || minAmount.toString().split('.')[1].length > 2)
            ) {
                document.getElementById('inputOpeningBal').value = minAmount.substring(0, minAmount.length - 1);
                return;
            }
            openingBalance = minAmount.replace('$', '');
            openingBalanceTemp = 'Changed';
            getRequiredFieldsOfAccountInfo();
        });
        typeDropdown.addEventListener('change', event => {
            typeTemp = 'Changed';
            type = event.target.value;
            getRequiredFieldsOfAccountInfo();
        });
        statusDropdown.addEventListener('change', event => {
            statusTemp = 'Changed';
            status = event.target.value;
            getRequiredFieldsOfAccountInfo();
        });
        classDropdown.addEventListener('change', event => {
            classofAccountTemp = 'Changed';
            classofAccount = event.target.value;
            getRequiredFieldsOfAccountInfo();
        });
    }

    function getRequiredFieldsOfAccountInfo() {
        var openDateVal = opendDate.querySelector('#opendDate');
        var closeDateVal = closeDate.querySelector('#closeDate');
        var nameVal = inputName.querySelector('#inputName');
        var typeVal = typeDropdown.querySelector('#typeDropdown');
        var statusVal = statusDropdown.querySelector('#statusDropdown');
        var classval = classDropdown.querySelector('#classDropdown');
        checkRequiredFieldsOfAccountInfo(
            nameVal.value,
            typeVal.value,
            statusVal.value,
            openDateVal.value,
            closeDateVal.value,
            classval.value
        );
    }

    function checkRequiredFieldsOfAccountInfo(nameVal, typeVal, statusVal, openDateVal, closeDateVal, classVal) {
        if (nameVal.trim() === '') {
            inputName.classList.add('error');
        } else {
            inputName.classList.remove('error');
        }

        if (typeVal === '') {
            typeDropdown.classList.add('error');
        } else {
            typeDropdown.classList.remove('error');
        }

        if (statusVal === '') {
            statusDropdown.classList.add('error');
        } else {
            statusDropdown.classList.remove('error');
        }

        if (openDateVal === '') {
            opendDate.classList.add('error');
        } else {
            opendDate.classList.remove('error');
        }

        if (closeDateVal != null && closeDateVal != '' && openDateVal > closeDateVal) {
            closeDate.classList.add('error');
        } else {
            closeDate.classList.remove('error');
        }

        if (classVal === '' || classVal == null) {
            classDropdown.classList.add('error');
        } else {
            classDropdown.classList.remove('error');
        }
        setBtnStatusOfAccountInfo();
    }

    function setBtnStatusOfAccountInfo() {
        var hasErrors = [].slice.call(document.querySelectorAll('.error'));
        if (hasErrors.length !== 0) {
            SAVE_BTN.classList.add('disabled');
            return;
        } else {
            if (
                nameTemp != '' ||
                numberTemp != '' ||
                typeTemp != '' ||
                statusTemp != '' ||
                classofAccountTemp != '' ||
                dateOpenedTemp != '' ||
                dateClosedTemp != '' ||
                openingBalanceTemp != '' ||
                descriptionTemp != ''
            ) {
                if (accountId == '0' && page == 'Update') {
                    SAVE_BTN.classList.add('disabled');
                } else {
                    SAVE_BTN.classList.remove('disabled');
                }
            } else {
                SAVE_BTN.classList.add('disabled');
            }
        }
    }

    function cancleAccount() {
        if (page == 'Add') {
            page = 'Update';
            load = 1;
            loadCFEditLanding();
        } else {
            roster2.clearSelectedConsumers();
            roster2.clearActiveConsumers();
            CFEditAccount.init();
        }
    }

    async function saveUpdateAccount() {
        if (page == 'Add') {
            accountId = '0';
        }

        if (dateClosed == '') dateClosed = null;
        const result = await ConsumerFinancesAjax.insertEditRegisterAccountAsync(
            selectedConsumersId,
            accountId,
            name,
            number == '' ? null : number,
            type,
            status,
            classofAccount == '' ? null : classofAccount,
            dateOpened,
            dateClosed,
            openingBalance,
            description == '' ? null : description,
        );
        const { insertEditRegisterAccountResult } = result;
        if (insertEditRegisterAccountResult.accountId != null) {
            page = 'Update';
            loadCFEditLanding();
        }
    }

    async function attachmentEditPopup(isActive = false, accountId, account) {
        const result = await ConsumerFinancesAjax.getAccountAttachments(accountId, isActive);
        const { getAccountAttachmentsResult } = result;
        newAttachmentArray = [];
        accountAttachments = getAccountAttachmentsResult;
        numberOfRows = accountAttachments.length;
        editAttachmentPopup = POPUP.build({
            hideX: true,
            id: "editAttachmentPopup"
        });

        editAttachmentPopup.style.maxWidth = '65%';
        editAttachmentPopup.style.left = '50%';

        showInactive = input.buildCheckbox({
            text: 'Show Inactive',
            id: 'chkShowInactive',
            isChecked: isActive,
            callback: () => {
                POPUP.hide(editAttachmentPopup);
                attachmentEditPopup(event.target.checked, accountId, account);
            }
        });

        const popupHeader = document.createElement("div");
        popupHeader.classList.add("popupHeader");
        const headerWrap = document.createElement("div");
        headerWrap.classList.add("editRelationshipInputWrap");
        const headerText = document.createElement("div");
        headerText.innerHTML = account + " Attachments";
        headerWrap.appendChild(headerText);
        headerWrap.appendChild(showInactive);
        popupHeader.appendChild(headerWrap);
        editAttachmentPopup.appendChild(popupHeader);

        for (let i = 0; i < numberOfRows; i++) {
            await createPopupElements(i, accountAttachments);
            editAttachmentPopup.appendChild(btnWrapInputsN[i]);
        }

        saveAttachmentBtn = button.build({
            id: "saveAttachmentBtn",
            text: "save",
            type: "contained",
            style: "secondary",
            classNames: 'disabled',
            callback: async () => {
                if (!saveAttachmentBtn.classList.contains('disabled')) {     
                    saveAttachmentBtn.classList.add('disabled'); 
                    await editAttachmentSaveData(accountId);      
                    saveAttachmentBtn.classList.remove('disabled');  
                }
            }
        });

        AddAttachmentBtn = button.build({
            id: "AddAttachmentBtn",
            text: "New",
            type: "contained",
            style: "secondary",
            callback: async () => {
                if (!AddAttachmentBtn.classList.contains('disabled')) {
                    editAttachmentPopup.style.display = 'none';
                    attachmentPopup();
                }
            },
        });

        cancelAttachmentBtn = button.build({
            id: "cancelAttachmentBtn",
            text: "cancel",
            type: "outlined",
            style: "secondary",
            callback: () => {
                POPUP.hide(editAttachmentPopup);
                resetPopupValues();
            },
        });

        attachmentPopupBtnWrap = document.createElement("div");
        attachmentPopupBtnWrap.classList.add("editRelationshipBtnWrap");
        attachmentPopupBtnWrap.appendChild(saveAttachmentBtn);
        attachmentPopupBtnWrap.appendChild(AddAttachmentBtn);
        attachmentPopupBtnWrap.appendChild(cancelAttachmentBtn);
        editAttachmentPopup.appendChild(attachmentPopupBtnWrap);
        POPUP.show(editAttachmentPopup);
        await populateEditAttachmentCategoryDropdown();
        isValueChanged = false;
        checkRequiredFieldsEditAccountAttachments();
        popUpAttachementEventHandlers();
        if ($.session.CFInsert)
            AddAttachmentBtn.classList.remove('disabled');
        else
            AddAttachmentBtn.classList.add('disabled');
    }

    async function createPopupElements(i, getAccountAttachmentsResult) {
        descriptionInputN[i] = input.build({
            id: 'descriptionInputN' + i,
            type: 'text',
            label: 'Description:',
            style: 'secondary',
            readonly: ($.session.CFUpdateEditAccounts || !getAccountAttachmentsResult) ? false : true, 
            value: getAccountAttachmentsResult == null ? '' : getAccountAttachmentsResult[i].description,
        });

        if (getAccountAttachmentsResult) {
            downloadBtnN[i] = button.build({
                id: 'downloadBtnN' + getAccountAttachmentsResult[i].attachmentID,
                type: 'text',
                icon: 'show',
                style: 'secondary',
                callback: function (event) {
                    isValueChanged = true;
                    var attachmentID = Number(event.target.closest('button').id.replace('downloadBtnN', ''));
                    ConsumerFinancesAjax.viewAccountAttachment(attachmentID);
                },
            });
        }
        else {
            downloadBtnN[i] = button.build({
                id: 'downloadBtnN',
                type: 'text',
                style: 'secondary',
            });
        }

        categoryDropdownN[i] = dropdown.build({
            id: 'categoryDropdownN' + i,
            label: "Category:",
            readonly: ($.session.CFUpdateEditAccounts || !getAccountAttachmentsResult) ? false : true,
            dropdownId: "categoryDropdownN" + i,
        });

        startDateInputN[i] = input.build({
            id: 'startDateInputN' + i,
            type: 'date',
            label: 'Start Date:',
            style: 'secondary',
            readonly: ($.session.CFUpdateEditAccounts || !getAccountAttachmentsResult) ? false : true,
            value: getAccountAttachmentsResult == null ? '' : moment(getAccountAttachmentsResult[i].startDate).format('YYYY-MM-DD'),
        });

        endDateInputN[i] = input.build({
            id: 'endDateInputN' + i,
            type: 'date',
            label: 'End Date:',
            style: 'secondary',
            readonly: ($.session.CFUpdateEditAccounts || !getAccountAttachmentsResult) ? false : true, 
            value: getAccountAttachmentsResult == null ? '' : moment(getAccountAttachmentsResult[i].endDate).format('YYYY-MM-DD'),
        });

        deleteBtnN[i] = button.build({
            id: 'deleteBtnN' + i,
            type: 'text',
            icon: 'delete',
            style: 'secondary',
            callback: function (event) {
                var deleteToId = Number(event.target.closest('button').id.replace('deleteBtnN', ''));
                deleteConfirmAttachmentPOPUP(deleteToId);
            },
        });

        btnWrapInputsN[i] = document.createElement("div");
        btnWrapInputsN[i].classList.add("editRelationshipInputWrap");
        descriptionInputN[i].classList.add('width22Per');
        btnWrapInputsN[i].appendChild(descriptionInputN[i]);
        downloadBtnN[i].classList.add('width4Per');
        btnWrapInputsN[i].appendChild(downloadBtnN[i]);
        categoryDropdownN[i].classList.add('width22Per');
        btnWrapInputsN[i].appendChild(categoryDropdownN[i]);
        startDateInputN[i].classList.add('width22Per');
        btnWrapInputsN[i].appendChild(startDateInputN[i]);
        endDateInputN[i].classList.add('width22Per');
        btnWrapInputsN[i].appendChild(endDateInputN[i]);
        deleteBtnN[i].classList.add('width4Per');
        if ($.session.CFDelete)
            btnWrapInputsN[i].appendChild(deleteBtnN[i]);
    }
    function popUpAttachementEventHandlers() {
        for (let i = 0; i < numberOfRows; i++) {
            if (deletedIds.includes(i)) {
                continue;
            }

            startDateInputN[i].addEventListener('input', event => {
                isValueChanged = true;
                checkRequiredFieldsEditAccountAttachments();
            });
            endDateInputN[i].addEventListener('input', event => {
                isValueChanged = true;
                checkRequiredFieldsEditAccountAttachments();
            });

            descriptionInputN[i].addEventListener('input', async event => {
                isValueChanged = true;
                checkRequiredFieldsEditAccountAttachments();
            });
            categoryDropdownN[i].addEventListener('change', event => {
                isValueChanged = true;
                checkRequiredFieldsEditAccountAttachments();
            });
        }
    }

    function checkRequiredFieldsEditAccountAttachments() {
        for (let i = 0; i < numberOfRows; i++) {
            if (deletedIds.includes(i)) {
                continue;
            }
            var descriptionText = descriptionInputN[i].querySelector('#descriptionInputN' + i);
            var categoryValue = categoryDropdownN[i].querySelector('#categoryDropdownN' + i);
            var startDate = startDateInputN[i].querySelector('#startDateInputN' + i);
            var endDate = endDateInputN[i].querySelector('#endDateInputN' + i);

            if (descriptionText.value === '') {
                descriptionInputN[i].classList.add('errorPopup');
            } else {
                descriptionInputN[i].classList.remove('errorPopup');
            }

            if (categoryValue.value === '') {
                categoryDropdownN[i].classList.add('errorPopup');
            } else {
                categoryDropdownN[i].classList.remove('errorPopup');
            }

            if (startDate.value != '' && endDate.value != '' && startDate.value > endDate.value) {
                endDateInputN[i].classList.add('errorPopup');
            } else {
                endDateInputN[i].classList.remove('errorPopup');
            }

            if (startDate.value === '' && endDate.value != '') {
                startDateInputN[i].classList.add('errorPopup');
            } else {
                startDateInputN[i].classList.remove('errorPopup');
            }
        }
        setBtnStatusEditAccountAttachments();
    }

    function setBtnStatusEditAccountAttachments() {
        var hasErrors = [].slice.call(document.querySelectorAll('.errorPopup'));
        if (hasErrors.length !== 0) {
            saveAttachmentBtn.classList.add('disabled');
            return;
        } else {
            if (isValueChanged)
                saveAttachmentBtn.classList.remove('disabled');
            else
                saveAttachmentBtn.classList.add('disabled');
        }
    }

    async function populateEditAttachmentCategoryDropdown() {

        const {
            getAttachmentCategoryResult: AttachmentCate,
        } = await ConsumerFinancesAjax.getAttachmentCategory();
        categoryAttachmentData = AttachmentCate.map((attachmentCate) => ({
            id: attachmentCate.CategoryID,
            value: attachmentCate.CategoryID,
            text: attachmentCate.CategoryDescription
        }));
        categoryAttachmentData.unshift({ id: null, value: '', text: '' });
        for (let i = 0; i < numberOfRows; i++) {
            dropdown.populate("categoryDropdownN" + i, categoryAttachmentData, accountAttachments[i] != undefined ? accountAttachments[i].category : '');
        }
    }

    function deleteConfirmAttachmentPOPUP(deleteToId) {
        editAttachmentPopup.style.display = 'none';
        const confirmPopup = POPUP.build({
            hideX: true,
        });

        YES_BTN = button.build({
            text: 'YES',
            style: 'secondary',
            type: 'contained',
            callback: () => {
                POPUP.hide(confirmPopup);
                isValueChanged = true;
                editAttachmentPopup.style.display = 'block';
                overlay.show();
                btnWrapInputsN[deleteToId].style.display = 'none';
                if (!deletedIds.includes(deleteToId)) {
                    deletedIds.push(deleteToId);
                }
                checkRequiredFieldsEditAccountAttachments();
                popUpAttachementEventHandlers();
            },
        });

        NO_BTN = button.build({
            text: 'NO',
            style: 'secondary',
            type: 'outlined',
            callback: () => {
                POPUP.hide(confirmPopup);
                editAttachmentPopup.style.display = 'block';
                overlay.show();
            },
        });

        const message = document.createElement('p');

        message.innerText = 'Are you sure you would like to delete this attachment?';
        message.style.textAlign = 'center';
        message.style.marginBottom = '15px';
        confirmPopup.appendChild(message);
        var popupbtnWrap = document.createElement('div');
        popupbtnWrap.classList.add('btnWrap');
        popupbtnWrap.appendChild(YES_BTN);
        popupbtnWrap.appendChild(NO_BTN);
        confirmPopup.appendChild(popupbtnWrap);
        YES_BTN.focus();
        POPUP.show(confirmPopup);
    }

    async function editAttachmentSaveData(accountId) {
        const updatedAttachmentList = [];
        const deletedAttachmentList = [];
        const newAttachmentList = [];

        for (let i = 0; i < numberOfRows; i++) {
            if (deletedIds.includes(i)) {
                if (accountAttachments[i] && accountAttachments[i].attachmentID) {
                    const relationshipToDelete = {
                        attachmentID: accountAttachments[i].attachmentID,
                    };
                    deletedAttachmentList.push(relationshipToDelete);
                }
                continue;
            }
            const descriptionText = descriptionInputN[i].querySelector('#descriptionInputN' + i);
            const categoryValue = categoryDropdownN[i].querySelector('#categoryDropdownN' + i);
            const startDate = startDateInputN[i].querySelector('#startDateInputN' + i);
            const endDate = endDateInputN[i].querySelector('#endDateInputN' + i);
            if (!descriptionText || !categoryValue || !startDate || !endDate) {
                continue;
            }
            let attchId = accountAttachments[i] && accountAttachments[i].attachmentID ? accountAttachments[i].attachmentID : undefined;
            if (!attchId) {
                let attachmentData = newAttachmentArray.find((rel) => rel.rowId == i);
                let abString = await ConsumerFinancesAjax.convertBinaryToString(attachmentData.arrayBuffer);

                const newData = {
                    description: descriptionText.value || '',
                    category: categoryValue.options[categoryValue.selectedIndex].id || '',
                    startDate: startDate.value || '',
                    endDate: endDate.value || '',
                    attachment: abString,
                    attachmentType: attachmentData.type
                };
                newAttachmentList.push(newData)
            }

            if (attchId) {
                let originalData;
                originalData = accountAttachments.find(
                    (rel) => rel.attachmentID == attchId
                );

                if (originalData && accountAttachments[i]) {
                    originalData = accountAttachments[i];
                }

                const newData = {
                    attachmentID: accountAttachments[i].attachmentID,
                    description: descriptionText.value || '',
                    category: categoryValue.options[categoryValue.selectedIndex].id || '',
                    startDate: startDate.value || '',
                    endDate: endDate.value || ''
                };
                // Helper function to normalize dates for comparison
                function normalizeDate(dateStr) {
                    if (!dateStr) return '';
                    if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
                        return dateStr;
                    }
                    const date = new Date(dateStr);
                    if (!isNaN(date.getTime())) {
                        return date.toISOString().split('T')[0];
                    }
                    return dateStr;
                }
                const originalStartDate = normalizeDate(originalData.startDate);
                const originalEndDate = normalizeDate(originalData.endDate);
                const originalDescription = originalData.description ? originalData.description : '';
                const originalCategory = originalData.category ? originalData.category.toString() : '';

                const newStartDate = normalizeDate(newData.startDate);
                const newEndDate = normalizeDate(newData.endDate);
                const newDescription = newData.description ? newData.description : '';
                const newCategory = newData.category ? newData.category.toString() : '';

                const startDateChanged = originalStartDate !== newStartDate;
                const endDateChanged = originalEndDate !== newEndDate;
                const DescriptionChanged = originalDescription !== newDescription;
                const categoryChanged = originalCategory !== newCategory;

                const hasChanges = startDateChanged || endDateChanged || DescriptionChanged || categoryChanged;

                if (hasChanges) {
                    updatedAttachmentList.push(newData);
                }
            }
        }

        if (updatedAttachmentList.length > 0 || deletedAttachmentList.length > 0 || newAttachmentList.length > 0) {
            await ConsumerFinancesAjax.insertUpdateAccountAttachment(updatedAttachmentList, deletedAttachmentList, newAttachmentList, accountId, selectedConsumersId);   
            POPUP.hide(editAttachmentPopup);
            page = 'Update';
            load = 2;
            loadCFEditLanding();       
        }
        resetPopupValues();
    }

    function resetPopupValues() {
        btnWrapInputsN = [];
        descriptionInputN = [];
        startDateInputN = [];
        categoryDropdownN = [];
        endDateInputN = [];
        deleteBtnN = [];
        downloadBtnN = [];
        accountAttachments = [];
        deletedIds = [];
        newAttachmentArray = [];
    }

    function attachmentPopup() {
        const popup = POPUP.build({
            header: 'Attachments',
            id: 'cnAttachmentPopup',
        });

        const saveBtn = button.build({
            id: 'attachmentSave',
            text: 'Done',
            style: 'secondary',
            type: 'contained',
            callback: () => {              
                saveAttachmentAction();  
                POPUP.hide(popup);
                editAttachmentPopup.style.display = 'block';
                overlay.show();  
            },
        });
        const cancelBtn = button.build({
            id: 'attachmentCancel',
            text: 'cancel',
            style: 'secondary',
            type: 'outlined',
            callback: () => {
                POPUP.hide(popup);
                editAttachmentPopup.style.display = 'block';
                overlay.show(); 
            },
        });

        reviewAttachmentList = document.createElement('div');
        reviewAttachmentList.classList.add('reviewAttachmentList');
        newAttachmentList = document.createElement('div');
        newAttachmentList.classList.add('newAttachmentList');
        const newAttachmentsHeader = document.createElement('h5');
        newAttachmentsHeader.innerText = 'Attachments to be added:';
        newAttachmentList.appendChild(newAttachmentsHeader);


        attachmentInput = document.createElement('input');
        attachmentInput.type = 'file';
        attachmentInput.classList.add('input-field__input', 'attachmentInput');
        attachmentInput.onchange = event => fileValidation(event.target);

        attachmentContainer = document.createElement('div');
        attachmentContainer.classList.add('attachmentContainer');
        attachmentList = document.createElement('form');
        attachmentList.setAttribute('id', 'attachmentForm');
        attachmentList.appendChild(attachmentContainer);
        attachmentContainer.appendChild(attachmentInput);

        const btnWrap = document.createElement('div');
        btnWrap.classList.add('btnWrap');

        popup.appendChild(reviewAttachmentList);
        popup.appendChild(newAttachmentList);
        popup.appendChild(attachmentList);

        btnWrap.appendChild(saveBtn);
        btnWrap.appendChild(cancelBtn);
        popup.appendChild(btnWrap);
        POPUP.show(popup);
    }

    function fileValidation(target) {
        const fileType = target.files[0].type;
        const reFileTypeTest = new RegExp('(audio/)|(video/)');
        if (reFileTypeTest.test(fileType)) {
            alert('Anywhere currently does not accept audio or video files');
            target.value = '';
            return false;
        }
        var MAX_FILE_SIZE = 5 * 1024 * 1024;
        if (target.files[0].size > MAX_FILE_SIZE) {
            alert('The file exceeds the size limit and cannot be attached.');
            target.value = '';
            return false;
        }
    }
    function saveAttachmentAction() {
        const attachmentInputs = document.querySelectorAll('.attachmentInput');
        if (attachmentInputs.length === 0) {          
            return;
        }       
        let attachmentProms = [];

        attachmentInputs.forEach(inputElement => {
            if (inputElement.value === '') {
                return;
            }
            const attPromise = new Promise(resolve => {
                const attachmentObj = {};
                const attachmentFile = inputElement.files.item(0);
                const attachmentName = attachmentFile.name;
                const attachmentType = attachmentFile.name.split('.').pop();
                attachmentObj.rowId = numberOfRows;
                attachmentObj.description = attachmentName;
                attachmentObj.type = attachmentType;
                // new Response(file) was added for Safari compatibility
                new Response(attachmentFile).arrayBuffer().then(res => {
                    attachmentObj.arrayBuffer = res;
                    newAttachmentArray.push(attachmentObj);
                    resolve();
                });
            });

            attachmentProms.push(attPromise);
        });

        Promise.all(attachmentProms).then(res => {
            addAttachmentData();
        });
    }

    async function addAttachmentData() {       
        let i = numberOfRows;
        numberOfRows = numberOfRows + 1;
        await createPopupElements(i, null);
        editAttachmentPopup.insertBefore(btnWrapInputsN[i], attachmentPopupBtnWrap);
        dropdown.populate("categoryDropdownN" + i, categoryAttachmentData, '');
        popUpAttachementEventHandlers();
        checkRequiredFieldsEditAccountAttachments();
    }

    function init() {
        setActiveModuleAttribute('CFEditAccount');
        DOM.clearActionCenter();
        let defaultCFLocation = defaults.getLocation('moneyManagement');
        if (defaultCFLocation === '') {
            defaults.setLocation('moneyManagement', 0);
            defaultCFLocation = '0';
        }
        roster2.miniRosterinit(
            {
                locationId: defaultCFLocation,
                locationName: '',
            },
            {
                hideDate: true,
            },
        );

        roster2.showMiniRoster();
    }

    function getaccountPermission() {
        accountPermission = '';
        tempAccountPer = [];
        if ($.session.CFViewChecking) tempAccountPer.push('Checking');

        if ($.session.CFViewCraditCard) {
            tempAccountPer.push('Credit Card');
        }

        if ($.session.CFViewFoodStamp) {
            tempAccountPer.push('Food Stamps');
        }

        if ($.session.CFViewPettyCash) {
            tempAccountPer.push('Petty Cash');
        }

        if ($.session.CFViewShaving) {
            tempAccountPer.push('Savings');
        }

        if ($.session.CFViewChristmasClub) {
            tempAccountPer.push('Christmas Club');
        }
        if ($.session.CFViewSystem20183A) {
            tempAccountPer.push('System 2018.3A');
        }
        if ($.session.CFViewSystem20183) {
            tempAccountPer.push('System 2018.3');
        }
        if ($.session.CFViewOhioEBT) {
            tempAccountPer.push('Ohio EBT');
        }
        if ($.session.CFViewViewFoodStampDebitCardEBT) {
            tempAccountPer.push('Food Stamp Debit Card EBT');
        }

        if (tempAccountPer.length > 0) {
            accountPermission = tempAccountPer.toString();
        } else accountPermission = '';
    }

    return {
        init,
        handleActionNavEvent,
        loadCFEditLanding,
        loadCFEditFromAccountRegister,
    };
})();
